import React, { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { PageSection } from 'reaxl';
import { useDevice } from '@bonnet/next/device';
import RecentSearches from '@/component/RecentSearches';

import { callToActionAnalytics, dealerLotAnalytics } from '@/analytics';
import { recentSearchDuck } from '@/ducks';

const handleStaticClick = ({ recentSearches, event, index }) => {
    if (recentSearches.length) {
        callToActionAnalytics.fireContinueYourSearchClick(event, recentSearches, index);

        let srpURL = recentSearches[index].url;

        //  temporary hack b/c of corrupted recent search urls only containing querystring
        if (srpURL && srpURL.charAt(0) === '?') {
            srpURL = '/cars-for-sale/searchresults.xhtml' + srpURL;
        }

        window.location.assign(srpURL);
    }
};

const RecentSearchesContainer = React.memo(({
    uiContext = 'buttons',
}) => {
    const dispatch = useDispatch();
    const device = useDevice();

    const recentSearches = useSelector(recentSearchDuck.selectors.getRecentSearches) || [];

    const [impressionHasFired, setImpressionHasFired] = useState(false);

    useEffect(() => {
        dispatch(recentSearchDuck.creators.hydrateRecentSearches());
    }, []);

    const handleStaticClickCallback = useCallback((event, index) => {
        handleStaticClick({
            recentSearches,
            event,
            index,
        });
    }, [recentSearches]);

    const handleImpression = () => {
        if (!impressionHasFired) {
            callToActionAnalytics.fireContinueYourSearchImpression();
        }
        setImpressionHasFired(true);
    };

    const handleCarouselArrowClick = (event, direction) => {
        const isRecentSearches = true;
        dealerLotAnalytics.fireReaxleLotArrowClick(event, direction, isRecentSearches);
    };

    return recentSearches.length > 0 && (
        <PageSection
            id="rightCar"
            data-cmp="continueSearches"
            uiContext="section-2"
            headingComponentClass="p"
            headingClassName="margin-left-3 text-primary"
            heading="Pick Up Where You Left Off"
            alignment="left"
            offset={1}
        >
            <RecentSearches
                data={recentSearches}
                collapsed={device.lessThan.md}
                onStaticClick={handleStaticClickCallback}
                onReady={handleImpression}
                onNextButtonClick={(e) => handleCarouselArrowClick(e, 'next')}
                onPrevButtonClick={(e) => handleCarouselArrowClick(e, 'previous')}
                uiContext={uiContext}
                className="margin-left-3 margin-top-1"
            />
        </PageSection>
    );

});

RecentSearchesContainer.propTypes = {
    uiContext: PropTypes.string,
    recentSearches: PropTypes.array,
};

export default RecentSearchesContainer;
